import config from "../config/config";
import { userService } from "../services";

export const changepasswordAction={
    changePassword,
}

async function changePassword(payload) {
    console.log(payload,"payloadddd")
    
    try {
        let apiEndpoint =  `${config.baseUrl}${config.apiName.changePassword}`
        
        let response = await userService.post(apiEndpoint,payload);
        console.log(response,"response");
        if (response && response.status == 200 ) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}